import EdiFile from ".";

export const ediFileRoutes = [
  {
    path: "/edi-file",
    element: <EdiFile />,
  },
];
